import { jsx as _jsx } from "react/jsx-runtime";
import { ElementRenderer, generateElementKey } from '../ElementRenderer.js';
import { getLayoutStyles } from '../layout.js';
import { cn } from '../lib/utils.js';
/**
 * Nav element with proper styling for mobile bottom navigation
 * and desktop sidebar navigation
 * Adds background and appropriate border for visual separation
 */
export function Nav({ element }) {
    const layoutStyles = getLayoutStyles(element);
    const { props } = element;
    // Check positioning and orientation
    const isSticky = props.sticky === true;
    const isRow = props.row === true;
    const isBottom = props.bottom !== undefined;
    const isRight = props.right !== undefined;
    // Determine border based on position
    // Bottom nav: border-top
    // Side nav: border-right (default) or border-left (if right-side)
    const borderClass = isRow ? (isBottom ? 'border-t' : '') : isRight ? 'border-l' : 'border-r';
    return (_jsx("nav", { className: cn('box-border bg-background border-border', borderClass, isSticky && 'z-10'), style: layoutStyles, children: element.children.map((child, index) => (_jsx(ElementRenderer, { node: child }, generateElementKey(child, index)))) }));
}
//# sourceMappingURL=Nav.js.map